import React from "react";
import { ShieldCheck, FileCheck2, HardHat, MapPin, Receipt, MessagesSquare } from "lucide-react";

const ITEMS = [
  [ShieldCheck, "Décennale · RC Pro · URSSAF vérifiées"],
  [HardHat, "Inscription gratuite · 8 % sur les chantiers réalisés"],
  [MapPin, "Chantiers par secteur"],
  [FileCheck2, "Attestations lues automatiquement"],
  [MessagesSquare, "Une conversation par chantier"],
  [Receipt, "Facturation Factur-X"],
];

export const Marquee = () => {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div className="marquee relative overflow-hidden bg-[#1B3A5C] text-white border-y border-white/10" data-testid="marquee" aria-label="Engagements VosCompagnons">
      <div className="marquee-track py-3.5 md:py-4">
        {row.map(([Icon, txt], i) => (
          <span key={i} className="flex items-center gap-3 px-6 md:px-10 font-display text-xs md:text-sm font-medium uppercase tracking-[0.16em] whitespace-nowrap">
            <Icon size={15} className="text-[#E8710A]" /> {txt}
            <span className="ml-6 md:ml-10 w-1.5 h-1.5 rounded-full bg-[#E8710A]" />
          </span>
        ))}
      </div>
    </div>
  );
};
